"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Filter = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _SearchField = _interopRequireDefault(require("../../SearchField/SearchField"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Filter = exports.Filter = function Filter(_ref) {
  var data = _ref.data,
    callbackSelected = _ref.callbackSelected,
    _ref$initialSelected = _ref.initialSelected,
    initialSelected = _ref$initialSelected === void 0 ? [] : _ref$initialSelected;
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    searchText = _useState2[0],
    setSearchText = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    filterItems = _useState4[0],
    setFilterItems = _useState4[1];

  // Initialize filter items when data changes
  (0, _react.useEffect)(function () {
    var items = data.map(function (item) {
      return {
        value: item,
        checked: initialSelected.includes(item)
      };
    });
    setFilterItems(items);
    if (initialSelected.length === 0) {
      setSearchText("");
    }
  }, [data, initialSelected]);

  // Initial notification after items are set
  (0, _react.useEffect)(function () {
    if (filterItems.length > 0) {
      var selectedItems = filterItems.filter(function (item) {
        return item.checked;
      }).map(function (item) {
        return item.value;
      });
      if (selectedItems.length > 0) {
        callbackSelected(selectedItems);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterItems.length]); // Only run when items are first loaded

  // Filter items based on search text
  var filteredItems = filterItems.filter(function (item) {
    return item.value.toLowerCase().includes(searchText.toLowerCase());
  });
  var handleChange = function handleChange(text) {
    setSearchText(text);
  };
  var handleItemChange = function handleItemChange(value, checked) {
    setFilterItems(function (prevItems) {
      var newItems = prevItems.map(function (item) {
        return item.value === value ? _objectSpread(_objectSpread({}, item), {}, {
          checked: checked
        }) : item;
      });
      // Call callback with the new selection
      var selectedItems = newItems.filter(function (item) {
        return item.checked;
      }).map(function (item) {
        return item.value;
      });
      callbackSelected(selectedItems);
      return newItems;
    });
  };
  var handleSelectAll = function handleSelectAll(checked) {
    var itemsToUpdate = searchText === "" ? filterItems : filteredItems;

    // Helper function to check if item should be updated
    var shouldUpdateItem = function shouldUpdateItem(item) {
      return itemsToUpdate.some(function (filteredItem) {
        return filteredItem.value === item.value;
      });
    };
    setFilterItems(function (prevItems) {
      var newItems = prevItems.map(function (item) {
        return shouldUpdateItem(item) ? _objectSpread(_objectSpread({}, item), {}, {
          checked: checked
        }) : item;
      });
      // Call callback with the new selection
      var selectedItems = newItems.filter(function (item) {
        return item.checked;
      }).map(function (item) {
        return item.value;
      });
      callbackSelected(selectedItems);
      return newItems;
    });
  };

  // Check if all visible items are selected
  var allVisibleSelected = filteredItems.length > 0 && filteredItems.every(function (item) {
    return item.checked;
  });
  var someVisibleSelected = filteredItems.some(function (item) {
    return item.checked;
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flow-column gap-10"
  }, /*#__PURE__*/_react["default"].createElement(_SearchField["default"], {
    searchText: searchText,
    setSearchText: handleChange,
    placeholder: "Search"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "items_filter_list"
  }, /*#__PURE__*/_react["default"].createElement(_material.FormGroup, null, filteredItems.length > 0 && /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
    control: /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
      checked: allVisibleSelected,
      indeterminate: someVisibleSelected && !allVisibleSelected,
      onChange: function onChange(e) {
        return handleSelectAll(e.target.checked);
      }
    }),
    label: "(Select All)"
  }), filteredItems.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
      key: item.value,
      control: /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
        checked: item.checked,
        onChange: function onChange(e) {
          return handleItemChange(item.value, e.target.checked);
        }
      }),
      label: item.value
    });
  }))));
};